module.exports = __webpack_public_path__ + "images/vlc_smalle16d83f38f348df506e753f4cfdea83e.png";